import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {AccountInvoiceData} from "./account-invoice.data";

@Injectable()
export class AccountInvoiceSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "chargeId"
    }
}
